import React, { ChangeEvent, forwardRef, useCallback, useImperativeHandle, useRef, useState } from "react";
import { RCCBadge, RCCButton, RCCGrid,  RCCHookToast, RCCInput, RCCInputMask, RCCRefModalProps, RCCSelectOptionsCard, RCCServicesApi, RCCSwitch, RCCTextArea } from "react-common-components";
import { useForm } from "react-hook-form";
import Audit from "src/components/Audit";
import DateTimePickerRange from "src/components/DateTimePickerRange";
import DeleteModal from "src/components/DeleteModal";
import { TagsTypes } from "src/components/FiltersTagsContainer/interface";
import InputNumber from "src/components/InputNumber";
import LovSectors from "src/components/Lov/Sectors";
import LovTags from "src/components/Lov/Tags";
import Modal from "src/components/Modal";
import RACI from "src/components/RACI";
import Select from "src/components/Select";

import Tabs from "src/components/Tabs";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { FormFieldsOnRight } from "src/pages/Actions/Panel/styles";
import { getValidationErrors, standardErrorMessages } from "src/utils/errors";
import extractSingleValueFromArrayOfObject from "src/utils/extractSingleValueFromArrayOfObject";
import stringToNumber from "src/utils/stringToNumber";
import ModalReorder from "src/components/ModalReorder";
import { IReorderRef } from "src/components/ModalReorder/interface";
import { IRefIRisksModals } from "src/pages/Risks/Panel/interface";
import ModalsRisks from "src/pages/Risks/Panel/modals";
import { IKanbanType } from "src/pages/Actions/Kanban/kanbanModes/MultipleKanbans/interface";
import LovKanban from "src/components/Lov/Kanban";
import {formatHoursInMinutes} from "src/utils/formartHourMinutes";
import LovProgram from "src/components/Lov/Program";
import returnStringValueForSelect from "src/utils/returnStringValueForSelect";
import { useConfirmModal } from "src/context/ConfirmModal/context";
import { ProjectModel, ProjectSituation } from "../Panel/interface";
import { IProgram } from "../Program/interface";
import Premisses from "./Components/Premisses";
import FormSimplifiedFields from "./Components/FormSimplifiedFields";
import Phases from "./Components/Phases";
import Restrictions from "./Components/Restrictions";
import { IProject, IProjectModal, IPrtba006001, IRefProjectModals } from "./interface";
import { addAndChangeSchemaProject, deleteSchemaProject } from "./schema";
import ProjetObjective from "./Components/Objective";
import Strategies from "./Components/Strategies";
import Risks from "./Components/Risks";

const ModalProject: React.ForwardRefRenderFunction<IRefProjectModals, IProjectModal> = ({
	onCallbackProgram,
	loadGroupers
}, ref) => {

	const { confirm } = useConfirmModal();
	const { translate, currentLanguage } = useTranslation();
	const {addToast} = RCCHookToast();
	const [projectSelected, setProjectSelected] = useState<IProject>({} as IProject);
	const [programSelected, setProgramSelected] = useState<IProgram>();
	const [controlHours, setControlHours] = useState(false);
	const [modelAgile, setModelAgile] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [isCopy, setIsCopy] = useState(false);
	const [titleModal, setTitleModal] = useState("");

	// Modal Add/Change
	const [isAdd, setIsAdd] = useState(false);
	const [formSimplified, setFormSimplified] = useState(true);
	const modalAddOrChange = useRef<RCCRefModalProps>(null);
	const modalReorderRef = useRef<IReorderRef>(null);
	const refModalRisks = useRef<IRefIRisksModals>(null);

	const { 
		handleSubmit : handleSubmitAddOrChange, 
		register : registerAddOrChange,
		unregister: unregisterAddOrChange,
		control: controlAddOrChange, 
		reset : resetAddOrChange, 
		setError : setErrorAddOrChange, 
		formState: { errors : errorsAddOrChange }, 
		clearErrors: clearErrorsAddOrChange,
		watch: watchAddOrChange,
		setValue: setValueAddOrChange
	} = useForm();

	const stringToNumberOrNull = (obj: any) => {
		if(typeof obj === "string" && obj === "")
			return null;
		if(typeof obj === "string")
			return parseInt(obj, 10);
		if(typeof obj !== "number")
			return null;
		return obj;
	};

	const submitConfirm = (data: any) => {
		if(!projectSelected.allActionsCompleted && data.pra002Situacao === ProjectSituation.CLOSED){
			confirm(
				translate("Ações não finalizadas"), 
				`${translate("Algumas ações do projeto ainda não foram finalizadas. Deseja finaliza-lo mesmo assim")}?`,
				() => {
					submitAddOrChange(data);
				},
				() => {},
				false
			);
			return;
		}

		submitAddOrChange(data);
	};

	const submitAddOrChange = async (data: any) => {
		let msgToastSuccess = "";
		let msgToastError = "";
		try{
			clearErrorsAddOrChange();
			modalAddOrChange.current?.setLoadingButton();

			await addAndChangeSchemaProject(translate, isAdd, data.pra002Dtiniest, data.pra002Dtfimest, data.pra002Validadatas).validate({...data}, {
				abortEarly: false
			});
		
			const dataForm = {
				...data,
				pra002Id: Number(data.pra002Id),
				pra002Taa001Id: data.pra002Taa001Id ? Number(data.pra002Taa001Id) : undefined,
				pra002ControlaHoras: data.pra002ControlaHoras ? "S" : "N",
				pra002Validadatas: data.pra002Validadatas === false ? "N" : "S",
				pra002Kba001Id: stringToNumberOrNull(data.pra002Kba001Id),
				pra002HorasEstimadas: controlHours ? formatHoursInMinutes(data.pra002HorasEstimadas) : null,
				pra002Pra001Id: isAdd ? programSelected?.pra001Id : stringToNumberOrNull(data?.pra002Pra001Id),
				pra002Notificaresponsavel: data.pra002Notificaresponsavel ? "S" : "N",
				pra002Notificaautoridade: data.pra002Notificaautoridade ? "S" : "N",
				pra002Tags: data.pra002Tags ? extractSingleValueFromArrayOfObject("value", data.pra002Tags) : undefined,
				pra002Vlrestimado: typeof data.pra002Vlrestimado === "string" ? stringToNumber(data.pra002Vlrestimado, currentLanguage) || 0 : data.pra002Vlrestimado || 0,
				pra002Vlrestreceita: typeof data.pra002Vlrestreceita === "string" ? stringToNumber(data.pra002Vlrestreceita, currentLanguage) || 0 : data.pra002Vlrestreceita || 0,
				pra002Situacao: isAdd ? 1 : data.pra002Situacao,
				prtba007: data.prtba007?.map((participant: any) => ({
					...participant,
					pra007Id: Number(participant.pra007Id),
					pra007Efa004Id: Number(participant.pra007Efa004Id),
					pra007Efa005Id: Number(participant.pra007Efa005Id),
					pra007Notificaparticipante: participant.pra007Notificaparticipante ? "S" : "N"
				})).filter((e: any) => e.pra007Efa004Id || e.pra007Efa005Id),
				prtba008: data.prtba008?.map((premisse: any, idx: number) => ({
					...premisse,
					pra008Id: Number(premisse.pra008Id),
					pra008Pra002Id: projectSelected?.pra002Id || 0,
					pra008Ordem: idx + 1
				})),
				prtba006: data.prtba006?.map((premisse: IPrtba006001) => ({
					...premisse,
					pra006Id: Number(premisse.pra006Id),
					pra006Mee001Id: Number(premisse.pra006Mee001Id),
					pra006Pra002Id: projectSelected?.pra002Id || 0
				})),
				prtba009: data.prtba009?.map((restriction: any, idx: number) => ({
					...restriction,
					pra009Id: Number(restriction.pra009Id),
					pra009Pra002Id: projectSelected?.pra002Id || 0,
					pra009Ordem: idx + 1
				}))
			};

			if(modelAgile){
				if(isAdd){
					dataForm.prtba003 = [{
						pra003Id: 0,
						pra003Titulo: "Backlog",
						pra003Pra002Id: 0,
						pra003Ordem: 1,
						pra003Vlrestimado: 0,
						pra003Vlrestreceita: 0,
						pra003Peso: 1,
						pra003Situacao: 1
					}];
				}else{
					dataForm.prtba003 = projectSelected?.prtba003;
				}
			}else{
				dataForm.prtba003 = data.prtba003?.map((phase: any, idx: number) => ({
					...phase,
					pra003Id: Number(phase.pra003Id),
					pra003Pra002Id: projectSelected?.pra002Id || 0,
					pra003Vlrestimado: typeof phase.pra003Vlrestimado === "string" ? stringToNumber(phase.pra003Vlrestimado, currentLanguage) || 0 : phase.pra003Vlrestimado || 0,
					pra003Vlrestreceita: typeof phase.pra003Vlrestreceita === "string" ? stringToNumber(phase.pra003Vlrestreceita, currentLanguage) || 0 : phase.pra003Vlrestreceita || 0,
					pra003Horasestimadas: controlHours ? formatHoursInMinutes(phase.hoursminutes) : null,
					pra003Ordem: idx + 1,
					pra003Situacao: 1
				}));
			}

			if(isAdd){
				await RCCServicesApi.postRequest({
					method: "Project/Insert",	
					body:{
						...dataForm
					}
				});

				msgToastSuccess=translate("Projeto adicionado com sucesso");
				msgToastError=translate("Erro ao adicionar projeto");
				onCallbackProgram(programSelected?.pra001Id || projectSelected?.pra002Pra001Id || 0);

			}else if(isCopy){
				await RCCServicesApi.putRequest({
					method: "Project/Copy",
					body: {
						prtba002: {...dataForm},
						currentLanguage
					}
				});
				msgToastSuccess=translate("Projeto copiado com sucesso");
				msgToastError=translate("Erro ao copiar projeto");

				if((returnStringValueForSelect(dataForm.pra002Pra001Id) !== returnStringValueForSelect(projectSelected?.pra002Pra001Id)) && loadGroupers)
					loadGroupers();
				else
					onCallbackProgram(projectSelected?.pra002Pra001Id);
					
			}else{
				await RCCServicesApi.putRequest({
					method: "Project/Update",
					body: {
						...dataForm
					}
				});

				msgToastSuccess=translate("Projeto alterado com sucesso");
				msgToastError=translate("Erro ao alterar projeto");


				if((returnStringValueForSelect(dataForm.pra002Pra001Id) !== returnStringValueForSelect(projectSelected?.pra002Pra001Id)) && loadGroupers)
					loadGroupers();
				else
					onCallbackProgram(projectSelected?.pra002Pra001Id);
			}

			addToast({
				color: "green",
				description: msgToastSuccess,
				title: translate("Sucesso")
			});

			modalAddOrChange.current?.resetLoadingButton();
			modalAddOrChange.current?.closeModal();

		}catch(err: any){
			modalAddOrChange.current?.resetLoadingButton();
			if(getValidationErrors(err, setErrorAddOrChange)){
				addToast({
					color: "yellow",
					description: translate("Verifique os campos e tente novamente"),
					title: translate("Atenção")
				});
				return;
			}
				
			standardErrorMessages(err, msgToastError, addToast);
		}
	};

	async function getProject(id: number){
		const result = await RCCServicesApi.getRequest({
			method: "Project/Select",
			urlParameters: {id}
		});
		setProjectSelected(result.data);
		setControlHours(result.data.pra002ControlaHoras === "S");
		setIsDisabled(result.data.pra002Situacao === ProjectModel.AGILE);
		setModelAgile(result.data.pra002Modelo === ProjectModel.AGILE);
		modalAddOrChange.current?.openModal();
	}

	const onChangeTypeSelect = (value: string) => {
		setModelAgile(value === String(ProjectModel.AGILE));
	};

	// Modal Delete Objective
	const modalDelete = useRef<RCCRefModalProps>(null); 
	const { 
		handleSubmit: handleSubmitDelete, 
		register: registerDelete, 
		reset: resetDelete, 
		setError: setErrorDelete, 
		formState: { errors : errorsDelete }, 
		clearErrors: clearErrorsDelete 
	} = useForm();

	const submitDelete = useCallback(async (data: any) => {
		try{
			clearErrorsDelete();	
			modalDelete.current?.setLoadingButton();

			await deleteSchemaProject(translate).validate({...data, "pra002TituloConfirmation": projectSelected?.pra002Titulo},{
				abortEarly: false
			});
			
			await RCCServicesApi.deleteRequest({
				method: "Project/Delete",
				urlParameters: {
					id: projectSelected?.pra002Id,
					title: projectSelected?.pra002Titulo
				}
			});

			addToast({
				color: "green",
				description: translate("Projeto excluído com sucesso"),
				title: translate("Sucesso")
			});
			modalDelete.current?.resetLoadingButton();
			modalDelete.current?.closeModal();

			onCallbackProgram(programSelected?.pra001Id || projectSelected?.pra002Pra001Id || 0);

		}catch(err){
			modalDelete.current?.resetLoadingButton();

			if(getValidationErrors(err, setErrorDelete))
				return;

			standardErrorMessages(err, translate("Erro ao excluir projeto"), addToast);
		}
		
	}, [projectSelected]);

	const setEstimatedHours = (estimatedHours: number) => `${Math.floor(estimatedHours / 60).toString().padStart(4, "0")}:${(estimatedHours % 60).toString()}`;

	const actionButtonAdd = (program: IProgram) => {
		resetAddOrChange();
		setIsCopy(false); 
		setIsAdd(true);
		setTitleModal("Adicionar Projeto");
		setControlHours(false);
		setModelAgile(false);
		setFormSimplified(true);
		setProgramSelected(program);
		setProjectSelected({
			pra002Kba001Id: program.pra001Kba001Id
		} as IProject);
		modalAddOrChange.current?.openModal();
	};

	const actionButtonChange = (projectId: number, copy: boolean) => {
		resetAddOrChange(); 
		setIsAdd(false);
		setIsCopy(copy);
		setTitleModal(copy ? "Copiar Projeto" : "Alterar Projeto");
		setFormSimplified(false);
		getProject(projectId);
	};

	const actionButtonDelete = (projectId: number, projectName: string, programId: number) => {
		resetDelete();
		setProjectSelected({
			pra002Id: projectId,
			pra002Titulo: projectName,
			pra002Pra001Id: programId
		} as IProject);
		modalDelete.current?.openModal();
	};

	const actionButtonReorder = (program: IProgram) => {
		modalReorderRef.current?.openModalReorder({
			pra002Id: program.pra001Id
		}, `${translate("Programa")}: ${program.pra001Titulo}` );
	};

	const iconModal = () => {
		if(isAdd) return "plus";
		if(isCopy) return "copy";
		return "pencil";
	};

	useImperativeHandle(ref, () => ({
		actionButtonAdd,
		actionButtonChange,
		actionButtonDelete,
		actionButtonReorder
	}));

	return(
		<>
			{/* Modal Delete */}
			<DeleteModal
				ref={modalDelete}
				title= {translate("Exclusão do Projeto")}
				description= {`${translate("Deseja realmente excluir o projeto")}: ${projectSelected?.pra002Titulo}?`}
				onSubmit = {handleSubmitDelete(submitDelete)} 
				height="250px"
			>
				<RCCGrid
					container
					item
					xs={10}
				>
					<RCCInput 
						register={registerDelete}
						name="pra002Titulo"
						label={translate("Digite o título do projeto para excluí-lo")}
						maxLength={200}
						error={errorsDelete.pra002Titulo}
						required
					/>
				</RCCGrid>
			</DeleteModal>

			{/* Modal Add an Change */}
			<Modal
				ref={modalAddOrChange}
				header={{
					title: translate(titleModal),
					subtitle: isAdd ? `${translate("Programa")}: ${programSelected?.pra001Titulo}` : `${translate("Projeto")}: ${projectSelected?.fullTitle}`,
					icon: {
						name:  iconModal() 
					}
				}}
				onSubmit={handleSubmitAddOrChange(submitConfirm)}
				footer={{
					showSaveButton: true,
					buttonLoadingText: translate("Carregando"),
					saveButtonText: isCopy ? translate("Copiar") : translate("Salvar"),
					cancelButtonText: translate("Cancelar"),
					childrenOfStandardFooter: <>
						{isAdd && (
							<RCCButton color="blue" size="sm" onClick={() => {
								const pra002Titulo = watchAddOrChange("pra002Titulo");
								let pra002Efa005Id = watchAddOrChange("pra002Efa005Id");

								if(typeof pra002Efa005Id === "object")
									pra002Efa005Id = pra002Efa005Id.value;

								let pra002Efa005Id2 = watchAddOrChange("pra002Efa005Id2");

								if(typeof pra002Efa005Id2 === "object")
									pra002Efa005Id2 = pra002Efa005Id2.value;

								const pra002Dtiniest = watchAddOrChange("pra002Dtiniest");
								const pra002Dtfimest = watchAddOrChange("pra002Dtfimest");

								let pra002Kba001Id = watchAddOrChange("pra002Kba001Id");

								if(typeof pra002Kba001Id === "object")
									pra002Kba001Id = pra002Kba001Id.value;

								const prtba003 = watchAddOrChange("prtba003");

								setProjectSelected((prevState) => ({
									...prevState,
									pra002Titulo,
									pra002Dtiniest,
									pra002Dtfimest,
									pra002Efa005Id,
									pra002Efa005Id2,
									pra002Kba001Id,
									prtba003
								}));

								setFormSimplified((prevState) => !prevState);
							}}>
								{formSimplified ? translate("Ver cadastro completo") : translate("Ver cadastro simplificado")}
							</RCCButton>
						)}
					</>
				}}
			>
				{formSimplified ? (
					<RCCGrid
						container
						item
						direction="column"
						alignItems="center"	
					>
						<RCCGrid
							container
							item
							xs={12}
							sm={10}
							md={8}
							lg={8}
						>
							<RCCSelectOptionsCard
								control={controlAddOrChange}
								name="pra002Modelo"
								label=" "
								defaultValue={modelAgile ? "2" : "1"}
								options={[{
									label: translate("Tradicional"),
									value: "1"
								},{
									label: translate("Ágil"),
									value: "2"
								}]}
								onChange={onChangeTypeSelect}
								disabled={isDisabled || projectSelected.prtba003?.length > 0}
							/>
						</RCCGrid>	

						<FormSimplifiedFields 
							isDisabled={isDisabled || false}
							modelAgile={modelAgile}
							projectSelected={projectSelected || {} as IProject}
							control={controlAddOrChange}
							errors={errorsAddOrChange}
							register={registerAddOrChange}
							unregister={unregisterAddOrChange}
							clearErrors={clearErrorsAddOrChange}
							setValue={setValueAddOrChange}
							controlHours={controlHours}
						/>
					</RCCGrid>
				) : (
					<Tabs
						name="projetcs-tab"
						tabInit={0}
						options={[{
							label: translate("Geral"),
							content: (
								<RCCGrid
									container
									item
									direction="column"
									alignItems="center"
								>
									<RCCGrid
										container
										item
										xs={12}
										sm={10}
										md={8}
										lg={8}
									>
										<RCCGrid
											container
											item
											alignItems="center"
											justifyContent="flex-end"
										>
											{
												!isAdd &&
												<Title color="purple">
													{translate("Código")}: {projectSelected.pra002Codigo}
												</Title>
											}
											{
												projectSelected && <Audit data={projectSelected} type="pop"/>
											}
										</RCCGrid>
										<RCCGrid
											container
											item
										>
											<RCCSelectOptionsCard
												control={controlAddOrChange}
												name="pra002Modelo"
												label=" "
												defaultValue={modelAgile ? "2" : "1"}
												options={[{
													label: translate("Tradicional"),
													value: "1"
												},{
													label: translate("Ágil"),
													value: "2"
												}]}
												onChange={onChangeTypeSelect}
												disabled={isDisabled || projectSelected.prtba003?.length > 0}
											/>		
										</RCCGrid>
										<RCCGrid 
											styleInline="display: none"
										>
											<RCCInput 
												register={registerAddOrChange}
												name="pra002Id"
												label=""
												defaultValue={projectSelected?.pra002Id || 0}
												readOnly
											/>
										</RCCGrid>
										<RCCGrid
											container
											item
										>
											<RCCInput 
												register={registerAddOrChange}
												name="pra002Titulo"
												label={translate("Título")}
												maxLength={200}
												defaultValue={isCopy ? `(${translate("CÓPIA")}) ${projectSelected?.pra002Titulo}` : projectSelected?.pra002Titulo}
												error={errorsAddOrChange.pra002Titulo}
												disabled={isDisabled}
												required
											/>
										</RCCGrid>
										{!isAdd && (
											<RCCGrid
												container
												item
											>
												<LovProgram
													control={controlAddOrChange}
													name="pra002Pra001Id"
													label={translate("Programa")}
													defaultValue={returnStringValueForSelect(projectSelected?.pra002Pra001Id)}
													error={errorsAddOrChange.pra002Pra001Id}
													disabled={isDisabled}
													isClearable={false}
													required
												/>
											</RCCGrid>
										)}
										<RCCGrid
											container
											item
										>
											<RCCInput 
												register={registerAddOrChange}
												name="pra002Descricao"
												label={translate("Descrição")}
												maxLength={200}
												defaultValue={projectSelected?.pra002Descricao}
												error={errorsAddOrChange.pra002Descricao}
												disabled={isDisabled}
											/>
										</RCCGrid>
										<RCCGrid
											container
											item
										>
											<RCCTextArea 
												register={registerAddOrChange}
												name="pra002Objetivo"
												label={translate("Objetivo")}
												maxLength={4000}
												defaultValue={projectSelected.pra002Objetivo}
												error={errorsAddOrChange.pra002Objetivo}
												disabled={isDisabled}									
											/>
										</RCCGrid>
										<RCCGrid
											container
											item
										>
											<RCCTextArea 
												register={registerAddOrChange}
												name="pra002Justificativa"
												label={translate("Justificativa")}
												maxLength={4000}
												defaultValue={projectSelected.pra002Justificativa}
												error={errorsAddOrChange.pra002Justificativa}
												disabled={isDisabled}									
											/>
										</RCCGrid>
										<RCCGrid
											container
											item
										>
											<LovSectors 
												control={controlAddOrChange}
												name="pra002Taa001Id"
												label={translate("Setor")}
												defaultValue={projectSelected?.pra002Taa001Id ? String(projectSelected?.pra002Taa001Id) : undefined}
												isClearable
												isCreatable
												disabled={isDisabled}
											/>
										</RCCGrid>
										<RCCGrid
											container
											item
										>
											<LovKanban
												control={controlAddOrChange}
												name="pra002Kba001Id"
												label={translate("Kanban")}
												defaultValue={projectSelected?.pra002Kba001Id ? String(projectSelected?.pra002Kba001Id) : undefined}
												isClearable
												isCreatable
												error={errorsAddOrChange.pra002Kba001Id}
												extraParametersOnCreate={{
													type: IKanbanType.PROJECT
												}}
												extraParametersOnLoad={{
													type: IKanbanType.PROJECT
												}}
											/> 
										</RCCGrid>
										<RCCGrid
											container
											item
											style={{marginBottom: isAdd ? "15px" : ""}}
										>
											<LovTags 
												control={controlAddOrChange}
												name="pra002Tags"
												label={translate("Tags")}
												defaultValue={Array.isArray(projectSelected?.pra002Tags) ? projectSelected?.pra002Tags.join(", ") : projectSelected?.pra002Tags}
												extraParametersOnLoad={{
													use: TagsTypes.PROJECTS
												}}
												extraParametersOnCreate={{
													use: TagsTypes.PROJECTS
												}}
												disabled={isDisabled}
											/>
										</RCCGrid>
										{
											!isAdd &&
											<RCCGrid
												container
												item
												xs={5}
												style={{marginBottom: "15px"}}
											>
												<Select 
													control={controlAddOrChange}
													name="pra002Situacao"
													label={translate("Situação")}
													defaultValue={String(projectSelected.pra002Situacao) || ProjectSituation.OPEN}
													options= {[{
														label: translate("Aberta"),
														value: ProjectSituation.OPEN
													},{
														label: translate("Fechada"),
														value: ProjectSituation.CLOSED
													}]}
												/>
											</RCCGrid>
										}
									</RCCGrid>
									<hr />
									{/* DATAS/HORAS */}
									<RCCGrid
										container
										item
										direction="column"
										xs={12}
										sm={10}
										md={8}
										lg={8}
									>
										<Title 
											color="purple"
											marginBottom={15}
										>
											{translate("Datas/Horas")}
										</Title>
										<RCCGrid
											container
											item
										>
											<RCCSwitch 
												name="pra002Validadatas" 
												label={translate("Valida datas da ação com fase/projeto")} 
												register={registerAddOrChange} 
												defaultChecked={projectSelected?.pra002Validadatas !== "N"}
												disabled={isDisabled}
											/>
										</RCCGrid>
										<RCCGrid
											container
											item
											justifyContent="space-between"
										>		
											<RCCGrid
												container
												item
												xs={12}
												sm={5}
											>
												<RCCSwitch 
													name="pra002ControlaHoras" 
													label={translate("Controlar Horas")} 
													register={registerAddOrChange} 
													defaultChecked={projectSelected?.pra002ControlaHoras === "S"}
													onChangeCapture={(e: ChangeEvent<HTMLInputElement>) => setControlHours(e.target.checked)}
													disabled={isDisabled}
												/>
											</RCCGrid>
											{
												controlHours && 
												<RCCGrid
													container
													item
													xs={12}
													sm={5}
												>
													<RCCInputMask 
														name="pra002HorasEstimadas" 
														control={controlAddOrChange}
														label={`${translate("Horas Estimadas")} (${translate("horas")}:${translate("minutos")})`} 
														defaultValue={setEstimatedHours(projectSelected?.pra002HorasEstimadas || 0)}
														format="####:##"
														error={errorsAddOrChange.pra002HorasEstimadas}
														required
														styleInline={FormFieldsOnRight}
														disabled={isDisabled}
													/>
												</RCCGrid>
											}	
										</RCCGrid>
										<RCCGrid
											container
											item
										>
											<DateTimePickerRange
												control={controlAddOrChange}
												type="datePicker"
												label={translate("Data Estimada")}
												labelSeparator={translate("Até")}
												nameInit="pra002Dtiniest"
												nameEnd="pra002Dtfimest"
												defaultValueInit={projectSelected?.pra002Dtiniest ? projectSelected?.pra002Dtiniest : new Date()}
												defaultValueEnd={projectSelected?.pra002Dtfimest ? projectSelected?.pra002Dtfimest : new Date()}
												error={errorsAddOrChange.pra002Dtiniest || errorsAddOrChange.pra002Dtfimest}
												required
												props={{
													datePicker: {
														disabled: isDisabled
													}
												}}
											/>
										</RCCGrid>
										{
											!isAdd &&
											<>
												<RCCGrid
													container
													item
												>
													<DateTimePickerRange
														control={controlAddOrChange}
														type="datePicker"
														label={translate("Data Prevista (Ações)")}
														labelSeparator={translate("Até")}
														nameInit="pra002Dtiniprev"
														nameEnd="pra002Dtfimprev"
														defaultValueInit={projectSelected?.pra002Dtiniprev ? projectSelected?.pra002Dtiniprev : ""}
														defaultValueEnd={projectSelected?.pra002Dtfimprev ? projectSelected?.pra002Dtfimprev : ""}
														error={errorsAddOrChange.pra002Dtiniprev || errorsAddOrChange.pra002Dtfimprev}
														props={{
															datePicker: {
																disabled: true
															}
														}}
													/>
												</RCCGrid>
												<RCCGrid
													container
													item
													style={{marginBottom: "15px"}}
												>
													<DateTimePickerRange
														control={controlAddOrChange}
														type="datePicker"
														label={translate("Data Real (Ações)")}
														labelSeparator={translate("Até")}
														nameInit="pra002Dtinireal"
														nameEnd="pra002Dtfimreal"
														defaultValueInit={projectSelected?.pra002Dtinireal ? projectSelected?.pra002Dtinireal : ""}
														defaultValueEnd={projectSelected?.pra002Dtfimreal ? projectSelected?.pra002Dtfimreal : ""}
														error={errorsAddOrChange.pra002Dtinireal || errorsAddOrChange.pra002Dtfimprev}
														props={{
															datePicker: {
																disabled: true
															}
														}}
													/>
												</RCCGrid>
											</>
										}
										
									</RCCGrid>
									<hr />
									{/* VALORES */}
									<RCCGrid
										container
										item
										justifyContent="space-between"
										xs={12}
										sm={10}
										md={8}
										lg={8}
									>
										<RCCGrid
											container
											item
											xs={12}>
											<Title 
												color="purple"
												marginBottom={15}
											>
												{translate("Valores")}
											</Title>
										</RCCGrid>
										<RCCGrid
											container
											item
											xs={12}
											sm={5}
										>
											<InputNumber 
												name="pra002Vlrestimado" 
												control={controlAddOrChange}
												label={translate("Valor Estimado Despesa")} 
												defaultValue={projectSelected?.pra002Vlrestimado || 0}
												error={errorsAddOrChange.pra002Vlrestimado}
												required
												disabled={isDisabled}
											/>
										</RCCGrid>
										<RCCGrid
											container
											item
											xs={12}
											sm={5}
										>
											<InputNumber 
												name="pra002Vlrestreceita" 
												control={controlAddOrChange}
												label={translate("Valor Estimado Receita")} 
												defaultValue={projectSelected?.pra002Vlrestreceita || 0}
												error={errorsAddOrChange.pra002Vlrestreceita}
												required
												disabled={isDisabled}
											/>
										</RCCGrid>
										{
											!isAdd && 
											<>
												<RCCGrid
													container
													item
													xs={12}
													sm={5}
												>
													<InputNumber 
														name="valor-previsto-despesa-acoes" 
														control={controlAddOrChange}
														label={translate("Valor Previsto Despesa (Ações)")} 
														defaultValue={projectSelected?.pra002Vlrprevisto || 0}
														disabled
													/>
												</RCCGrid>
												<RCCGrid
													container
													item
													xs={12}
													sm={5}
												>
													<InputNumber 
														name="valor-previsto-receita-acoes" 
														control={controlAddOrChange}
														label={translate("Valor Previsto Receita (Ações)")} 
														defaultValue={projectSelected?.pra002Vlrprevisto || 0}
														disabled
													/>
												</RCCGrid>
												<RCCGrid
													container
													item
													xs={12}
													sm={5}
												>
													<InputNumber 
														name="valor-real-despesa-acoes" 
														control={controlAddOrChange}
														label={translate("Valor Real Despesa (Ações)")} 
														defaultValue={projectSelected?.pra002Vlrrealizado || 0}
														disabled
													/>
												</RCCGrid>
												<RCCGrid
													container
													item
													xs={12}
													sm={5}
												>
													<InputNumber 
														name="valor-real-receita-acoes" 
														control={controlAddOrChange}
														label={translate("Valor Real Receita (Ações)")} 
														defaultValue={projectSelected?.pra002Vlrrealizado || 0}
														disabled
													/>
												</RCCGrid>
											</>
										}
										
									</RCCGrid>
								</RCCGrid>
							)
						},
						{
							label: translate("RACI"),
							content: (
								<RACI 
									responsible={{
										nameOfSelect: "pra002Efa005Id",
										nameOfCheckbox: "pra002Notificaresponsavel",
										defaultValue: {
											select: projectSelected?.pra002Efa005Id  ? projectSelected.pra002Efa005Id.toString() : "",
											checkbox: projectSelected?.pra002Notificaresponsavel
										}
									}}
									accountable={{
										nameOfSelect: "pra002Efa005Id2",
										nameOfCheckbox: "pra002Notificaautoridade",
										defaultValue: {
											select: projectSelected?.pra002Efa005Id2 ? projectSelected.pra002Efa005Id2.toString() : "",
											checkbox: projectSelected?.pra002Notificaautoridade
										}
									}}
									control={controlAddOrChange}
									register={registerAddOrChange}
									unregister={unregisterAddOrChange}
									clearErrors={clearErrorsAddOrChange}
									error={errorsAddOrChange}
									participants={{
										nameOfObject: "prtba007",
										nameOfID: "pra007Id",
										nameOfCheckbox: "pra007Notificaparticipante",
										nameOfSelectGroup: "pra007Efa004Id",
										nameOfSelectGroupDescription: "pra007Efa004Nome",
										nameOfSelectUser: "pra007Efa005Id",
										nameOfSelectUserDescription: "pra007Efa005Nome",
										nameOfType: "pra007Tipo",
										defaultValue: projectSelected?.prtba007
									}}
									disabled={isDisabled}
								/>
							)
						},
						{
							label: translate("Fases"),
							hidden: modelAgile,
							content: (
								<Phases
									control={controlAddOrChange}
									error={errorsAddOrChange}
									register={registerAddOrChange}
									unregister={unregisterAddOrChange}
									clearErrors={clearErrorsAddOrChange}
									setValue={setValueAddOrChange}
									controlHours={controlHours}
									phasesDefaultValue={projectSelected?.prtba003 || []}
									isDisabled={isDisabled}
									isCopy={isCopy}
								/>
							)
						},
						{
							label: translate("Objetivos"),
							hidden: modelAgile,
							content: (
								<ProjetObjective 
									subTitle={projectSelected.fullTitle}
									control={controlAddOrChange}
									error={errorsAddOrChange}
									objectivesDefaultValue={projectSelected.prtba005 ? projectSelected.prtba005  : []}
									disabled={false}
									register={registerAddOrChange}
									clearErrors={clearErrorsAddOrChange}
									names={{
										nameOfID: "pra005Id",
										nameOfObject: "prtba005",
										nameOfRangeSlider: "pra005Peso",
										nameOfSelectObjective: "pra005Mea003Nome",
										nameOfIdSelectObjective: "pra005Mea003Id",
										nameOfMap: "mea001Nome"
									}}
								/>
							)
						},
						{
							label: translate("Estratégias"),
							hidden: modelAgile,
							content: (
								<>
									<Strategies 
										control={controlAddOrChange}
										error={errorsAddOrChange}
										register={registerAddOrChange}
										clearErrors={clearErrorsAddOrChange}
										setValue={setValueAddOrChange}
										strategiesDefaultValue={projectSelected.prtba006 ?? []}
										disabled={isDisabled}
									/>
								</>
							)
						},
						{
							label: translate("Riscos"),
							hidden: isAdd || modelAgile || isCopy,
							content: (
								<>
									<Risks 
										setValue={setValueAddOrChange}
										refModalRisks={refModalRisks}
										risksDefaultValue={projectSelected.prtba010 ?? []}
										disabled={isDisabled}
										projectSelected={projectSelected}
									/>
								</>
							)
						},
						{
							label: translate("Premissas"),
							content: (
								<Premisses
									control={controlAddOrChange}
									error={errorsAddOrChange}
									register={registerAddOrChange}
									unregister={unregisterAddOrChange}
									clearErrors={clearErrorsAddOrChange}
									setValue={setValueAddOrChange}
									premisesDefaultValue={projectSelected?.prtba008 || []}
									disabled={isDisabled}
								/>
							)
						},
						{
							label: translate("Restrições"),
							content: (
								<Restrictions
									control={controlAddOrChange}
									error={errorsAddOrChange}
									register={registerAddOrChange}
									unregister={unregisterAddOrChange}
									clearErrors={clearErrorsAddOrChange}
									setValue={setValueAddOrChange}
									restrictionsDefaultValue={projectSelected?.prtba009 || []}
									disabled={isDisabled}
								/>
							)
						}
						]}>
					</Tabs>
				)}
			</Modal>

			{/* Modal Reorder Position */}
			<ModalReorder 
				ref={modalReorderRef}
				modalName={translate("Reordenar Projetos")}
				names={{
					nameForId: "pra002Id",
					nameForOrder: "pra002Ordem",
					nameForTitle: "pra002Titulo"
				}}
				routeToList="Project/ListOrder"
				routeToSave="Project/Reorder"
				onCallbackSave={(row: any) => onCallbackProgram(row.pra002Id)}
				badgeComponent={(row: any) => (
					<>
						<RCCBadge 
							color={row.pra002Situacao === 1 ? "green" : "red"}
							styleInline="font-size: 0.83rem;"
						>
							{row.pra002Situacao === 1 ? translate("Aberto") : translate("Fechado")}
						</RCCBadge>	
					</>
				)}
			/>

			<ModalsRisks 
				ref={refModalRisks} 
			/>

		</>	
	);
};

export default forwardRef(ModalProject);

